// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1l4vh","buttons":"SendReceipts_buttons__3LH7q","email":"SendReceipts_email__3M6bi","bookApptTitle":"SendReceipts_bookApptTitle__IbeUF"};